/* tslint:disable */
/* eslint-disable */
/**
 * Donio
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateDonationRequest
 */
export interface CreateDonationRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateDonationRequest
     */
    project: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDonationRequest
     */
    subproject?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDonationRequest
     */
    mode: CreateDonationRequestModeEnum;
    /**
     * Required for plus projects
     * @type {string}
     * @memberof CreateDonationRequest
     */
    reward?: string | null;
    /**
     * Optional for plus projects, mandatory for reward with variants
     * @type {string}
     * @memberof CreateDonationRequest
     */
    rewardVariant?: string | null;
    /**
     * Optional for plus projects, mandatory for certain rewards
     * @type {string}
     * @memberof CreateDonationRequest
     */
    note?: string | null;
    /**
     * Price in cents (1/100 of base unit of currency)
     * @type {number}
     * @memberof CreateDonationRequest
     */
    amountInCents: number;
    /**
     * Price in cents (1/100 of base unit of currency); If project has tips disabled, must be exactly 0
     * @type {number}
     * @memberof CreateDonationRequest
     */
    tipInCents: number;
    /**
     * 
     * @type {string}
     * @memberof CreateDonationRequest
     */
    currency: CreateDonationRequestCurrencyEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateDonationRequest
     */
    paymentMethod: CreateDonationRequestPaymentMethodEnum;
    /**
     * Required for registered
     * @type {string}
     * @memberof CreateDonationRequest
     */
    user?: string | null;
    /**
     * Required for unregistered
     * @type {string}
     * @memberof CreateDonationRequest
     */
    email?: string | null;
    /**
     * Required for unregistered, or if user doesnt have profile filled
     * @type {string}
     * @memberof CreateDonationRequest
     */
    firstName?: string | null;
    /**
     * Required for unregistered, or if user doesnt have profile filled
     * @type {string}
     * @memberof CreateDonationRequest
     */
    lastName?: string | null;
    /**
     * Required for receipt
     * @type {string}
     * @memberof CreateDonationRequest
     */
    fullName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDonationRequest
     */
    street?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDonationRequest
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDonationRequest
     */
    zip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDonationRequest
     */
    country?: string | null;
    /**
     * Required for shippable reward or project requiring phone number
     * @type {string}
     * @memberof CreateDonationRequest
     */
    phoneNumber?: string | null;
    /**
     * Either this or `birthdate` required for receipt
     * @type {string}
     * @memberof CreateDonationRequest
     */
    companyLegalId?: string | null;
    /**
     * Either this or `companyLegalId` required for receipt
     * @type {Date}
     * @memberof CreateDonationRequest
     */
    birthdate?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDonationRequest
     */
    donationReceipt?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDonationRequest
     */
    isGiftCertificateRequested?: boolean;
    /**
     * Required for gift certificate
     * @type {string}
     * @memberof CreateDonationRequest
     */
    giftCertificateRecipientName?: string | null;
    /**
     * Optional for gift certificate
     * @type {string}
     * @memberof CreateDonationRequest
     */
    giftCertificateDonorName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDonationRequest
     */
    newsletterOptOut?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDonationRequest
     */
    agreedToShareContact?: boolean;
    /**
     * Optional for good habit (auto)
     * @type {string}
     * @memberof CreateDonationRequest
     */
    goodHabitCategory?: string | null;
}


/**
 * @export
 */
export const CreateDonationRequestModeEnum = {
    Single: 'single',
    LongTerm: 'long-term'
} as const;
export type CreateDonationRequestModeEnum = typeof CreateDonationRequestModeEnum[keyof typeof CreateDonationRequestModeEnum];

/**
 * @export
 */
export const CreateDonationRequestCurrencyEnum = {
    Czk: 'CZK',
    Eur: 'EUR'
} as const;
export type CreateDonationRequestCurrencyEnum = typeof CreateDonationRequestCurrencyEnum[keyof typeof CreateDonationRequestCurrencyEnum];

/**
 * @export
 */
export const CreateDonationRequestPaymentMethodEnum = {
    Card: 'card',
    WireTransfer: 'wire-transfer',
    GoodHabit: 'good-habit',
    PaymentTerminal: 'payment-terminal'
} as const;
export type CreateDonationRequestPaymentMethodEnum = typeof CreateDonationRequestPaymentMethodEnum[keyof typeof CreateDonationRequestPaymentMethodEnum];


/**
 * Check if a given object implements the CreateDonationRequest interface.
 */
export function instanceOfCreateDonationRequest(value: object): value is CreateDonationRequest {
    if (!('project' in value) || value['project'] === undefined) return false;
    if (!('mode' in value) || value['mode'] === undefined) return false;
    if (!('amountInCents' in value) || value['amountInCents'] === undefined) return false;
    if (!('tipInCents' in value) || value['tipInCents'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    return true;
}

export function CreateDonationRequestFromJSON(json: any): CreateDonationRequest {
    return CreateDonationRequestFromJSONTyped(json, false);
}

export function CreateDonationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDonationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'project': json['project'],
        'subproject': json['subproject'] == null ? undefined : json['subproject'],
        'mode': json['mode'],
        'reward': json['reward'] == null ? undefined : json['reward'],
        'rewardVariant': json['rewardVariant'] == null ? undefined : json['rewardVariant'],
        'note': json['note'] == null ? undefined : json['note'],
        'amountInCents': json['amountInCents'],
        'tipInCents': json['tipInCents'],
        'currency': json['currency'],
        'paymentMethod': json['paymentMethod'],
        'user': json['user'] == null ? undefined : json['user'],
        'email': json['email'] == null ? undefined : json['email'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'fullName': json['fullName'] == null ? undefined : json['fullName'],
        'street': json['street'] == null ? undefined : json['street'],
        'city': json['city'] == null ? undefined : json['city'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'country': json['country'] == null ? undefined : json['country'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'companyLegalId': json['companyLegalId'] == null ? undefined : json['companyLegalId'],
        'birthdate': json['birthdate'] == null ? undefined : (new Date(json['birthdate'])),
        'donationReceipt': json['donationReceipt'] == null ? undefined : json['donationReceipt'],
        'isGiftCertificateRequested': json['isGiftCertificateRequested'] == null ? undefined : json['isGiftCertificateRequested'],
        'giftCertificateRecipientName': json['giftCertificateRecipientName'] == null ? undefined : json['giftCertificateRecipientName'],
        'giftCertificateDonorName': json['giftCertificateDonorName'] == null ? undefined : json['giftCertificateDonorName'],
        'newsletterOptOut': json['newsletterOptOut'] == null ? undefined : json['newsletterOptOut'],
        'agreedToShareContact': json['agreedToShareContact'] == null ? undefined : json['agreedToShareContact'],
        'goodHabitCategory': json['goodHabitCategory'] == null ? undefined : json['goodHabitCategory'],
    };
}

export function CreateDonationRequestToJSON(json: any): CreateDonationRequest {
    return CreateDonationRequestToJSONTyped(json, false);
}

export function CreateDonationRequestToJSONTyped(value?: CreateDonationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'project': value['project'],
        'subproject': value['subproject'],
        'mode': value['mode'],
        'reward': value['reward'],
        'rewardVariant': value['rewardVariant'],
        'note': value['note'],
        'amountInCents': value['amountInCents'],
        'tipInCents': value['tipInCents'],
        'currency': value['currency'],
        'paymentMethod': value['paymentMethod'],
        'user': value['user'],
        'email': value['email'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'fullName': value['fullName'],
        'street': value['street'],
        'city': value['city'],
        'zip': value['zip'],
        'country': value['country'],
        'phoneNumber': value['phoneNumber'],
        'companyLegalId': value['companyLegalId'],
        'birthdate': value['birthdate'] == null ? undefined : ((value['birthdate'] as any).toISOString()),
        'donationReceipt': value['donationReceipt'],
        'isGiftCertificateRequested': value['isGiftCertificateRequested'],
        'giftCertificateRecipientName': value['giftCertificateRecipientName'],
        'giftCertificateDonorName': value['giftCertificateDonorName'],
        'newsletterOptOut': value['newsletterOptOut'],
        'agreedToShareContact': value['agreedToShareContact'],
        'goodHabitCategory': value['goodHabitCategory'],
    };
}

